import { getParent, getMembers, types } from "mobx-state-tree";

export const LoggerModel = types
  .model({
    enabled: false,
  })
  .actions((self) => {
    const call = (method: string, message?: any, ...optionalParams: any[]) => {
      if (self.enabled) {
        (console as any)[method](`[${getMembers(getParent(self)).name}]`, message, ...optionalParams);
      }
    };

    return {
      debug(message?: any, ...optionalParams: any[]) {
        call("debug", message, ...optionalParams);
      },
      log(message?: any, ...optionalParams: any[]) {
        call("log", message, ...optionalParams);
      },
      info(message?: any, ...optionalParams: any[]) {
        call("info", message, ...optionalParams);
      },
      warn(message?: any, ...optionalParams: any[]) {
        call("warn", message, ...optionalParams);
      },
      error(message?: any, ...optionalParams: any[]) {
        call("error", message, ...optionalParams);
      },
    };
  });
